/* WTF -- first-party attribution capture onto cart attributes (D7, 2026-10-09).
 *
 * WHY: 25% of orders carry no UTM, Shopify keeps no click ids, and no landing page keeps its query string.
 * This script keeps the first touch and the last touch in localStorage and copies them to PRIVATE cart
 * attributes (names start with "_wtf_", so the checkout does not show them). Cart attributes persist onto the
 * order. Same mechanism as wtf-reddit-match-keys.js.
 *
 * HOW MANY REQUESTS: one POST to /cart/update.js at most per page view, and only when ALL of these hold:
 *   - a cart exists (the server-rendered item count on the include tag is above 0, OR the add-to-cart event just fired), and
 *   - the cart does not already hold the current set (the _wtf_sig attribute differs from the signature computed here).
 * It makes ZERO GET /cart.js calls. It never creates a cart: with no cart it waits for the theme's own "cart-update"
 * event (published by the product form, quick add and the cart). It never wraps fetch and never touches the cart drawer.
 *
 * ATTRIBUTES (only non-empty values are meaningful; empty values clear the old one):
 *   _wtf_ft_<field>  first touch   _wtf_lt_<field>  last touch   _wtf_sig  signature of the set
 *   <field> = source medium campaign content term fbclid gclid ttclid landing referrer ts
 *
 * Fails silently by design: nothing here may break a storefront page.
 */
(function () {
  'use strict';
  if (window.__wtfAttribution) return;
  window.__wtfAttribution = true;

  var STORE_KEY = 'wtf_attr_v1';     // localStorage: { ft: {...}, lt: {...} }
  var SENT_KEY = 'wtf_attr_sig';     // localStorage: signature last written successfully
  var MAX = 200;
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];
  var FIELDS = ['source', 'medium', 'campaign', 'content', 'term', 'fbclid', 'gclid', 'ttclid', 'landing', 'referrer', 'ts'];
  var wrote = false;                 // one update call per page view, ever

  // Server-rendered cart facts from the include tag (data-cart-items, data-cart-sig).
  var tag = document.currentScript || document.querySelector('script[src*="wtf-attribution"]');
  var hasLoadInfo = !!(tag && tag.hasAttribute('data-cart-items') && tag.hasAttribute('data-cart-sig'));
  var loadItems = hasLoadInfo ? parseInt(tag.getAttribute('data-cart-items'), 10) || 0 : 0;
  var loadSig = hasLoadInfo ? (tag.getAttribute('data-cart-sig') || '') : '';

  function allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp) {
        // analytics consent covers the touches; marketing consent covers the click ids. Skip all of it when either says false.
        if (typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false) return false;
        if (typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false) return false;
      }
    } catch (e) { /* unknown: carry on, no consent banner is on */ }
    return true;
  }

  function clean(v) {
    if (v === null || v === undefined) return '';
    return String(v).replace(/[\u0000-\u001f\u007f]/g, '').replace(/^\s+|\s+$/g, '').slice(0, MAX);
  }

  function hash(s) {                 // FNV-1a, 32 bit, hex. A change detector, not security.
    var h = 2166136261, i;
    for (i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = (h + (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24)) >>> 0;
    }
    return ('00000000' + h.toString(16)).slice(-8);
  }

  function readStore() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      return o && o.ft && o.lt ? o : null;
    } catch (e) { return null; }
  }

  function saveStore(o) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(o)); return true; } catch (e) { return false; }
  }

  function thisTouch() {
    var q, t = {}, hasParams = false, i, ref = '';
    try { q = new URLSearchParams(window.location.search); } catch (e) { q = null; }
    for (i = 0; i < PARAMS.length; i++) {
      var v = q ? clean(q.get(PARAMS[i])) : '';
      t[PARAMS[i].replace('utm_', '')] = v;
      if (v) hasParams = true;
    }
    t.landing = clean(window.location.pathname);
    try {
      if (document.referrer) {
        var host = new URL(document.referrer).hostname;
        if (host && host !== window.location.hostname) ref = host;
      }
    } catch (e) { ref = ''; }
    t.referrer = clean(ref);
    t.ts = new Date().toISOString().slice(0, 19) + 'Z';
    return { touch: t, hasParams: hasParams };
  }

  function sameTouch(a, b) {          // equal on every field except the timestamp
    var i;
    if (!a || !b) return false;
    for (i = 0; i < FIELDS.length - 1; i++) if ((a[FIELDS[i]] || '') !== (b[FIELDS[i]] || '')) return false;
    return true;
  }

  // First touch is written once and never overwritten. Last touch is overwritten only when this URL carries NEW tracking values.
  var pageStore = null;               // one capture per page view, so the timestamp cannot drift between calls
  function capture() {
    if (pageStore) return pageStore;
    var cur = thisTouch();
    var store = readStore();
    if (!store) {
      store = { ft: cur.touch, lt: cur.touch };
      if (!saveStore(store)) return null;   // storage unusable: do nothing rather than call every page a first touch
    } else if (cur.hasParams && !sameTouch(store.lt, cur.touch)) {
      store.lt = cur.touch;
      saveStore(store);
    }
    pageStore = store;
    return store;
  }

  function build(store) {
    var flat = {}, i, n, pairs = [], k;
    var sides = [['ft', store.ft], ['lt', store.lt]];
    for (n = 0; n < sides.length; n++) {
      for (i = 0; i < FIELDS.length; i++) {
        flat['_wtf_' + sides[n][0] + '_' + FIELDS[i]] = clean(sides[n][1] && sides[n][1][FIELDS[i]]);
      }
    }
    for (k in flat) if (flat[k]) pairs.push(k + '=' + flat[k]);
    pairs.sort();
    flat._wtf_sig = hash(pairs.join('|'));
    return flat;
  }

  // cartData is a full cart object when the theme publishes one (cart page changes). The add response has no attributes: then use the load-time facts.
  function needsWrite(sig, cartData) {
    if (cartData && typeof cartData.attributes === 'object' && cartData.attributes !== null && typeof cartData.item_count === 'number') {
      return cartData.item_count > 0 && cartData.attributes._wtf_sig !== sig;
    }
    if (hasLoadInfo && loadItems > 0 && loadSig === sig) return false;   // the cart already holds this exact set
    if (!hasLoadInfo) {
      try { return localStorage.getItem(SENT_KEY) !== sig; } catch (e) { return true; }
    }
    return true;
  }

  function maybeWrite(cartData, fromLoad) {
    try {
      if (wrote || !allowed()) return;
      if (fromLoad && !(hasLoadInfo && loadItems > 0)) return;   // never create a cart just to hold attributes
      var store = capture();
      if (!store) return;
      var payload = build(store);
      if (!needsWrite(payload._wtf_sig, cartData)) return;
      wrote = true;
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/update.js', {   // window.fetch at call time, so the theme's own in-flight counter sees it
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: payload }),
        credentials: 'same-origin',
        keepalive: true
      }).then(function (r) {
        if (r && r.ok) { try { localStorage.setItem(SENT_KEY, payload._wtf_sig); } catch (e) {} }
      }).catch(function () { /* never surface a tracking failure to a shopper */ });
    } catch (e) { /* silent */ }
  }

  // This tag runs BEFORE the deferred constants.js and pubsub.js (theme.liquid lines 53-55), so at start() `subscribe` is usually undefined.
  // DOMContentLoaded fires after every deferred script has run. A bounded retry covers a load that is slower than that.
  var hooked = false;
  function tryHook() {
    if (hooked) return true;
    try {
      if (typeof subscribe === 'function') {
        var ev = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
        subscribe(ev, function (d) {
          setTimeout(function () { maybeWrite(d && d.cartData, false); }, 0);
        });
        hooked = true;
      }
    } catch (e) { /* silent */ }
    return hooked;
  }

  function hook() {
    if (tryHook()) return;
    var tries = 0;
    var timer = setInterval(function () {                       // every 100 ms, up to 5 s
      tries++;
      if (tryHook() || tries >= 50) clearInterval(timer);
    }, 100);
    if (document.readyState !== 'complete') {
      document.addEventListener('DOMContentLoaded', function () {
        if (tryHook()) clearInterval(timer);
      });
    }
  }

  function start() {
    try {
      if (allowed()) capture();            // keep the touches even when no cart exists yet
      hook();
      setTimeout(function () { maybeWrite(null, true); }, 300);
    } catch (e) { /* silent */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
